import Vue from 'vue';
import axios from 'axios';

// 使用 Event Bus
const bus = new Vue(); 

export default bus;